module.exports = __webpack_public_path__ + "static/img/573_phase_function_Paper_PointsHejduk_Prediction.d5a1119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/573_phase_function_Paper_PointsHejduk_Prediction.png
// module id = vptU
// module chunks = 0